<template>
	<div class="content">
		<div class="login-wrap"></div>
		<div class="overContent">
			<div class="top_logo">
				<img style="height: 40px" src="../../src/assets/img/logo/logo1.png" />
				<img src="../../src/assets/img/logo/logo2.png" />
			</div>

			<span class="loginTitle">门店订单管理系统</span>
			<div class="login_area">
				<div class="login_title">欢迎登录系统</div>
				<div class="fenge_line"></div>
				<el-form ref="ruleForm" label-position="left" :model="ruleForm" :rules="rules" label-width="0px" class="demo-ruleForm">
					<el-form-item prop="username">
						<div class="user_name">
							<div class="el-icon-user-solid login_icon"></div>
							<div class="login_line"></div>
							<input v-model="ruleForm.username" class="input-class" type="text" size="small" auto-complete="off" placeholder="请输入账号" />
						</div>
					</el-form-item>
					<el-form-item prop="password">
						<div class="user_pwd">
							<div class="el-icon-lock login_icon"></div>
							<div class="login_line"></div>
							<input v-model="ruleForm.password" class="input-class" type="password" size="small" auto-complete="off" placeholder="请输入密码" />
						</div>
					</el-form-item>
					<el-form-item prop="validCode">
						<div class="user_code">
							<div class="el-icon-postcard login_icon"></div>
							<div class="login_line"></div>
							<input v-model="ruleForm.validCode" class="input-validCode" auto-complete="off" placeholder="请输入验证码" maxlength="4" />
							<img class="validCodeImg" :src="validCodeImg" @click="getValidCode" />
						</div>
					</el-form-item>
					<el-checkbox v-model="rememberpwd" class="remember">记住密码</el-checkbox>
					<el-form-item>
						<el-button id="validateCode" class="login_btn" type="primary" :loading="logining" @click="submitForm('ruleForm')" @keyup.enter.native="submitForm('ruleForm')">登 录</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="beian-info">
			<p>
				备案号：
				<a href="https://beian.miit.gov.cn">苏ICP备2025226708号-1</a>
				<span style="margin: 0 5px"></span>
				<img src="../../src/assets/beian/beian.png" alt="" style="height: 14px; width: 14px" />
				<span style="margin: 0 5px"></span>
				<a href="https://beian.mps.gov.cn/#/query/webSearch?code=32131102000937" rel="noreferrer" target="_blank">苏公网安备32131102000937号</a>
			</p>
			<!-- <p>京公网安备XXXXXXXX号</p> -->
			<p class="version-info">版本号：v{{ version }}</p>
		</div>
	</div>
</template>
<script>
import { LoginForValidCodeWeb, CreateValidCode } from "../api/userMG";
import { encryptMD5 } from "../utils/util.js";
export default {
	name: "Login",
	data() {
		return {
			// 系统版本号（打包时由 package.json 注入）
			version: process.env.VUE_APP_VERSION || "1.0.0",
			//定义loading默认为false
			logining: false,
			// 记住密码
			rememberpwd: true,
			url: "",
			ruleForm: {
				//username和password默认为空
				username: "",
				password: "",
				validCode: "",
				validKeyId: ""
			},
			validCodeImg: "",
			//rules前端验证
			rules: {
				username: [
					{
						required: true,
						message: "请输入账号",
						trigger: "blur"
					}
				],
				password: [
					{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}
				],
				validCode: [
					{
						required: true,
						message: "请输入验证码",
						trigger: "blur"
					}
				]
			},
			urlTicket: "",
			isUrlLogin: false
		};
	},
	mounted() {},
	// 创建完毕状态(里面是操作)
	created() {
		this.getuserpwd();
		this.getValidCode();
		var _self = this;
		document.onkeydown = function (e) {
			if (window.event == undefined) {
				var key = e.keyCode;
			} else {
				var key = window.event.keyCode;
			}
			if (key == 13) {
				_self.submitForm("ruleForm");
			}
		};
	},
	// 里面的函数只有调用才会执行
	methods: {
		mouseMove: function (e) {
			let x = e.offsetX; //相对元素的X偏移量
			let y = e.offsetY; //相对元素的Y偏移量
			let img = document.querySelector(".datong-box");
			let x1 = img.offsetWidth; //元素的宽度
			let y1 = img.offsetHeight; //元素的高度
			document.querySelector(".datong-box").style.cssText += "will-change: transform";
			document.querySelector(".datong-box").style.cssText += `transform:perspective(300px) rotateX(${(x1 / 2 - x) / 20}deg) rotateY(${(y1 / 2 - y) / 20}deg) scale3d(1.1,1.1,1.1)`;
		},
		mouseLeave: function () {
			document.querySelector(".datong-box").style.transform = "perspective(300px) rotateX(0deg) rotateY(0deg)";
		},

		// 获取用户名密码
		getuserpwd() {},
		//获取info列表
		submitForm(formName) {
			const that = this;
			that.$refs[formName].validate((valid) => {
				if (valid) {
					that.logining = true;
					var pwd = encryptMD5(that.ruleForm.password);
					var loginInfo = {
						userName: that.ruleForm.username,
						password: pwd,
						validCode: that.ruleForm.validCode,
						validKeyId: that.ruleForm.validKeyId,
						moduleType: 1,
						isUseCard: false
					};
					LoginForValidCodeWeb(loginInfo).then((res) => {
						if (res.code == 1) {
							//如果请求成功就让他2秒跳转路由
							setTimeout(() => {
								that.logining = false;
								// 写本地缓存：Storage 写失败（配额满 / 隐私模式）不能阻断跳转。
								// ⚠️ setTimeout 回调已脱离 Promise 链，异常连 .catch() 也捕获不到，
								// 必须就地 try/catch，否则会出现「登录成功但不跳转」的假死。
								try {
									const loginData = res.data || {};
									const loginUser = loginData.userInfo || {};
									localStorage.setItem(
										"loginInfo",
										JSON.stringify({
											userName: that.ruleForm.username,
											password: pwd
										})
									);
									sessionStorage.setItem("accessToken", loginData.token);
									// 缓存token
									localStorage.setItem("logintoken", loginData.token);
									// 缓存用户id
									localStorage.setItem("userId", loginUser.keyId);
									// 缓存用户个人信息
									localStorage.setItem("userdata", JSON.stringify(loginData));
								} catch (e) {
									console.error("[登录] 写本地缓存失败（不影响跳转）:", e);
								}
								that.$router.push({
									// path: '/exeIndex/noticeOne',
									path: "/exeIndex/mainIndex/workbench"
								});
								that.$permissionStore.commit("login", "true");
							}, 1000);
						} else {
							that.$message.error(res.msg);
							that.logining = false;
							// 验证码是一次性凭证：登录请求中它已被后端校验并作废（无论后续账号密码是否通过），
							// 失败后若沿用旧验证码重试，后端只会返回「验证码唯一标识不正确」。
							// 因此登录失败时自动换一张验证码，用户无需手动点图刷新。
							that.refreshValidCode();
							return false;
						}
					},
					// 仅处理「请求层」失败（网络异常 / 服务端 5xx），避免按钮永久停留在 loading。
					// 用 then 的第二个参数而不是 .catch()，是为了不把登录成功后的收尾异常也误判成登录失败。
					(err) => {
						that.logining = false;
						// 带 response 的 HTTP 错误已由响应拦截器统一提示，此处只兜底纯网络错误
						if (!err || !err.response) {
							that.$message.error("网络异常，请稍后重试");
						}
						that.refreshValidCode();
					}
					).catch((err) => {
						// 登录成功后的收尾动作（写缓存 / 跳转）若抛错，只记录，不打扰已登录的用户
						console.error("[登录] 登录后处理异常:", err);
					});
				} else {
					that.logining = false;
					return false;
				}
			});
		},
		// 登录失败后刷新验证码：换一张图 + 清空已输入的验证码，避免用户拿作废的验证码重试
		refreshValidCode() {
			this.ruleForm.validCode = "";
			this.getValidCode();
		},
		// 获取验证码
		getValidCode() {
			CreateValidCode({}).then((res) => {
				if (res.code == 1) {
					this.ruleForm.validKeyId = res.msg;
					this.validCodeImg = "data:image/png;base64," + res.data;
				}
			});
		}
	},

	unmounted() {
		document.onkeydown = undefined;
	}
};
</script>

<style scoped>
.login-wrap {
	background-image: url("../assets/img/login/loginbg.jpg");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
}

.content {
	box-sizing: border-box;
	width: 100%;
	height: 100vh;
	position: relative;
}

.overContent {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	/* display: flex; */
}

.top_logo {
	margin-top: 2%;
	margin-left: 3%;
	display: flex;
	align-items: center;
	width: 400px;
	height: 100px;
}

.top_logo img {
	width: auto;
	height: 60px;
}

.login_area {
	width: 528px;
	height: 420px;
	background: rgba(96, 112, 134, 0.2);
	box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.03);
	border-radius: 8px 8px 8px 8px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	margin-top: 2%;
	margin-left: 11%;
	/* display: flex; */
	align-items: center;
	justify-content: center;
	padding-left: 120px;
	padding-top: 70px;
}

.login_title {
	height: 48px;
	font-size: 32px;
	font-family: Source Han Sans CN-Bold, Source Han Sans CN;
	font-weight: bold;
	color: var(--app-surface);
	line-height: 38px;
}

.fenge_line {
	width: 70px;
	height: 3px;
	background: var(--app-primary-active);
	margin-top: 10px;
}

.user_name {
	width: 400px;
	height: 48px;
	background: rgba(41, 59, 83, 0.6);
	border-radius: 4px 4px 4px 4px;
	opacity: 1;
	/* margin-top: 48px; */
	display: flex;
	align-items: center;
}

.user_pwd {
	width: 400px;
	height: 48px;
	background: rgba(41, 59, 83, 0.6);
	border-radius: 4px 4px 4px 4px;
	opacity: 1;
	margin-top: 24px;
	display: flex;
	align-items: center;
}

.user_code {
	width: 100px;
	height: 48px;
	background: rgba(41, 59, 83, 0.6);
	border-radius: 4px;
	opacity: 1;
	margin-top: 24px;
	display: flex;
	align-items: center;
}

.remember {
	margin-top: 24px;
}

.login_btn {
	/* 登录按钮使用固定品牌配色，局部覆盖按钮变量以隔离全局主题。 */
	--app-primary: #2e5aa8;
	--app-primary-hover: #3c6dc0;
	--app-primary-active: #24487f;
	--app-button-hover: #23447e;
	--app-button-active: #1d3868;
	--app-primary-text: #2e5aa8;
	--app-primary-contrast: #ffffff;
	--app-primary-soft: #edf2fb;
	--app-primary-border: #c3d2ec;
	--app-surface: #ffffff;
	width: 400px;
	height: 48px;
	background: var(--app-primary);
	border-radius: 4px;
	opacity: 1;
	margin-top: 20px;
	border: none;
	font-size: 18px;
	font-family: Source Han Sans CN-Medium, Source Han Sans CN;
	font-weight: 500;
	color: var(--app-primary-contrast);
	transition-property: background, color;
	-webkit-transition-duration: 0.2s;
	transition-duration: 0.2s;
}

.login_icon {
	color: var(--app-text-muted);
	font-size: 24px;
	margin-left: 19px;
	margin-right: 19px;
}

.login_line {
	width: 1px;
	height: 28px;
	background: var(--app-text-muted);
	margin-right: 19px;
}

.input-class {
	width: calc(100% - 76px);
	background-color: transparent;
	border: none;
	outline: none;
	font-family: "Gudea", sans-serif;
	box-shadow: none;
	color: var(--app-text-muted) !important;
	margin-right: 20px;
}

.loginTitle {
	font-size: 48px;
	font-family: 楷体;
	font-weight: bold;
	background: linear-gradient(to top, var(--app-text-secondary), white);
	color: transparent;
	display: block;
	margin-left: 12%;
	-webkit-background-clip: text;
}

.user_code {
	width: 400px;
	height: 48px;
	background: rgba(41, 59, 83, 0.6);
	border-radius: 4px 4px 4px 4px;
	opacity: 1;
	/* margin-top: 48px; */
	display: flex;
	align-items: center;
}

.input-validCode {
	border: none;
	outline: none;
	width: 140px;
	height: 48px;
	background: transparent;
	box-shadow: none;
	color: var(--app-text-muted) !important;
}

.validCodeImg {
	width: 200px;
	height: 48px;
	cursor: pointer;
	border: none;
	outline: none;
	right: 0;
	border-radius: 4px;
}

.beian-info {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	text-align: center;
	font-size: 12px;
	color: black;
	line-height: 1.5;
}

.beian-info p {
	margin: 0;
}

.beian-info .version-info {
	margin-top: 2px;
	color: var(--app-text-muted);
	font-size: 12px;
}
</style>
